import { apiFetch } from './api';
import type { EnvironmentId } from '@/deploy/types';

export interface CdnConfig {
  enabled: boolean;
  sftpHost?: string;
  sftpPort?: number;
  sftpUser?: string;
  sftpPassword?: string;
  sftpPrivateKey?: string;
  basePath?: string;
  pathTemplate?: string;
  cacheClearCommand?: string;
}

export type CdnConfigsByEnv = Partial<Record<EnvironmentId, CdnConfig>>;

export const cdnConfigService = {
  /** Tous les envs en une requête (Map env → config). */
  listAll: (projectId: string) =>
    apiFetch<CdnConfigsByEnv>(`/api/projects/${projectId}/cdn-config`),

  /** Config d'un env donné. */
  get: (projectId: string, envId: EnvironmentId) =>
    apiFetch<CdnConfig>(`/api/projects/${projectId}/cdn-config/${envId}`),

  /** Met à jour la config d'un env donné. */
  update: (projectId: string, envId: EnvironmentId, cfg: CdnConfig) =>
    apiFetch<CdnConfig>(`/api/projects/${projectId}/cdn-config/${envId}`, {
      method: 'PUT',
      json: cfg,
    }),
};
